import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import AboutUs from './AboutUs';
import DevelopmentCard from './DevelopmentCard';
import Portfolio from './Portfolio';
import OurClients from './OurClients';
// import banner from '../pngs/banner.mp4'
import Blogs from './Blogs';
import Faq from './Faq';
// import ContactUs from './ContactUs';
import Testimonial from './Testimonial';
import { useLayoutEffect } from "react";
import Loader from './loader'; // Make sure the loader component exists
import Logo from '../pngs/omkatech-logo.png';
import '../components-css/body.scss';
import Header from './Header';
import axios from 'axios';
import bgVideo from '../../src/pngs/new-bg-video.mp4'
// import bgVideo from '../../src/pngs/christmas.mp4'
// import bgVideo from '../../src/pngs/happy-new-year.mp4'
// import bgVideo from '../../src/pngs/Comp.mp4'
import bgImg from '../pngs/393kb.png'
// import bgImg from '../pngs/chImg.jpg'
// import bgImg from '../pngs/new-year.jpg'
// import bgImg from '../pngs/Frame 27 (1).png'
import bgVideoMobile from '../../src/pngs/mobile-bg-video.mp4'
// import ConsultWithOmkatech from './ConsultWithOmkatech';
import { BASE_URL } from '../config';
// import PrivacyPolicy from '../pages/PrivacyPolicy';
import { Helmet } from 'react-helmet-async';
import diwaliImg from '../pngs/Frame 26.jpg'
import ArrowIcon from '../assets/svgs/black-arrow.svg';
import GradientArrowIcon from '../assets/svgs/Group 3 (5).svg'
import { Link } from "react-router-dom";

const Body = () => {
  const [aboutUsData, setAboutUsData] = useState(null);
  const [servicesData, setServicesData] = useState(null)
  const [isHovered, setIsHovered] = useState(false);
  const [brandsData, setBrandsData] = useState(null)
  // const [faqData, setFaqData] = useState(null)
  const [showLoader, setShowLoader] = useState(() => {
    const hasLoadedBefore = sessionStorage.getItem('hasLoadedBefore');
    return !hasLoadedBefore;
  });
  const [dataLoaded, setDataLoaded] = useState(false);
  const [testimonialData, setTestimonialData] = useState(null)
  const [blogsData, setBlogsData] = useState(null)
  const [isMobile, setIsMobile] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(() => {
    return sessionStorage.getItem('hasAnimated') === 'true';
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useLayoutEffect(() => {
    if (!dataLoaded) return;
  
    const savedScroll = sessionStorage.getItem("homeScrollPosition");
    if (!savedScroll) return;
  
    const scrollValue = parseInt(savedScroll);
  
    window.scrollTo(0, scrollValue - 180);
  
    sessionStorage.removeItem("homeScrollPosition");
  }, [dataLoaded]);  
  

  useEffect(() => {
    const fetchHomePageData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/GetHomeData`);
        setAboutUsData(response?.data?.data?.aboutus);
        setServicesData(response?.data?.data?.service)
        setBrandsData(response?.data?.data?.brand)
        setTestimonialData(response?.data?.data?.testimonial)
        setBlogsData(response?.data?.data?.Blog)
      } catch (error) {
        console.log(error);
      } finally {
        setDataLoaded(true);
        setShowLoader(false);
        sessionStorage.setItem('hasLoadedBefore', 'true');
        if (!hasAnimated) {
          sessionStorage.setItem('hasAnimated', 'true');
          setHasAnimated(true);
        }
      }
    };
    fetchHomePageData();
  }, []);

  return (
    <div className={`body-main-container ${showLoader ? 'loading' : ''}`}>
      {showLoader ? (
        <Loader /> // Display the loader while fetching data
      ) : !dataLoaded ? (
        <div><Loader /></div> // Show nothing while data is loading on subsequent visits
      ) : (
        <>
          <div className="banner-container">
            {/* <img className='background-video' src={diwaliImg} alt="" /> */}
            {/* <div className="content">
              <h2>THIS NEW YEAR</h2>
              <h2 className='animated-text'>UPGRADE YOUR ONLINE PRESENCE WITH</h2>
              <h4>EXCITING OFFERS!</h4>
              <div className="button">
                <Link
                  className="portfolio-page"
                  to="/contact-us"
                  style={{ textDecoration: 'none' }} // optional: remove underline
                >
                  <button
                    className="home-portfolio-btn"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                  >
                    <span>Connect with us Now</span>
                    <span className="img">
                      {isHovered ? (
                        <img src={GradientArrowIcon} alt="gradient-icon" />
                      ) : (
                        <img src={ArrowIcon} alt="arrow-icon" />
                      )}
                    </span>
                  </button>
                </Link>
              </div>

            </div> */}

            {/* normal ui */}
            {/* Background Video */}
            <video
              className="background-video"
              src={bgVideo}
              autoPlay
              muted
              loop
              playsInline
              poster={bgImg}
            >
              Your browser does not support the video tag.
            </video>

            <video
              className="background-video-mobile"
              src={bgVideoMobile}
              autoPlay
              muted
              loop
              playsInline
              poster={bgImg}
            >
              Your browser does not support the video tag.
            </video>

            <Header />
            {/* <div className="button header-btn">
                <Link
                  className="portfolio-page"
                  to="/contact-us"
                  style={{ textDecoration: 'none' }} // optional: remove underline
                >
                  <button
                    className="home-portfolio-btn"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                  >
                    <span className='btn-text'>BLACK FRIDAY DEALS</span>
                    <span className="img">
                      {isHovered ? (
                        <img src={GradientArrowIcon} alt="gradient-icon" />
                      ) : (
                        <img src={ArrowIcon} alt="arrow-icon" />
                      )}
                    </span>
                  </button>
                </Link>
              </div> */}
            <motion.div className="body-animation">
              <motion.span
                className="animated-text"
                initial={hasAnimated ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={hasAnimated ? { duration: 0 } : { duration: 1, ease: "easeOut" }}
                style={{ display: "inline-block" }}
              >
                <b>ACCELERATE</b> YOUR
              </motion.span>
              <br />
              <motion.span
                className="animated-text business"
                initial={hasAnimated ? {
                  clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                  opacity: 1,
                  scale: 1,
                  background: "linear-gradient(to left, #FFD80B, #FEAA00)",
                  backgroundSize: "200% 100%",
                  color: "#000",
                  y: 0,
                } : {
                  clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)",
                  opacity: 0,
                  scale: 0.9,
                  background: "linear-gradient(to left, #FFD80B, #FEAA00)",
                  backgroundSize: "200% 100%",
                  color: "#000",
                  y: 50,
                }}
                animate={{
                  clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                  opacity: 1,
                  scale: 1,
                  backgroundSize: "200% 100%",
                  color: "#000",
                  y: 0,
                }}
                transition={
                  hasAnimated
                    ? { duration: 0 }
                    : isMobile
                      ? {}
                      : {
                        duration: 1.5,
                        ease: "easeInOut",
                        backgroundPosition: { repeat: Infinity, duration: 2, ease: "linear" },
                      }
                }
              >
                <span className="create"><b>BUSINESS</b></span>
              </motion.span>
              <br />
              <motion.span
                className="animated-text"
                initial={hasAnimated ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={hasAnimated ? { duration: 0 } : { duration: 1, ease: "easeOut", delay: 0.4 }}
                style={{ display: "inline-block" }}
              >
                INTO THE <b>DIGITAL AGE</b>
              </motion.span>

            </motion.div>

          </div>
          <AboutUs />
          <DevelopmentCard servicesData={servicesData} />
          <Portfolio />
          <OurClients brandsData={brandsData} />
          {/* <CaseStudy /> */}
          <Testimonial testimonialData={testimonialData} />
          <Blogs blogsData={blogsData} />
          <Faq />
          {/* <PrivacyPolicy /> */}
        </>
      )}
    </div>

  );
};

export default Body;